"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var available_courses_controller_1 = __importDefault(require("./available-courses.controller"));
var available_courses_html_1 = __importDefault(require("./available-courses.html"));
function getStudent(UserService, $stateParams, UsersModel) {
    var currentUser = UserService.getCurrentUser();
    return UsersModel.getStudentByID(currentUser.id).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["UserService", "$stateParams", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.available-courses", {
        url: "/available-courses",
        controller: available_courses_controller_1.default,
        controllerAs: "vm",
        template: available_courses_html_1.default,
        resolve: {
            student: getStudent,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.available-courses", [])
    .config(config)
    .controller("StudentAvailableCoursesController", available_courses_controller_1.default);
